import { atom } from "recoil";

const selectedLogoAtom = atom({
  key: "selectedLogoState",
  default: [],
});

export default selectedLogoAtom;
